import type { ComponentPropsWithoutRef, FC } from "react";
import React from "react";

import { useHeadingTag } from "../hooks/useHeadingTag.ts";

export const H: FC<ComponentPropsWithoutRef<"h1">> = props => {
  const Tag = useHeadingTag();

  // oxlint-disable-next-line react-hooks/static-components
  return <Tag {...props} />;
};
